export default __webpack_public_path__ + "static/bg--contact--success-f394a718c00380a30287e08ada7b76ce.png";